import { SET_TWITCH_STREAMING, SET_TWITCH_NAME, SET_TWITCH_URL, UPDATE_TWITCH } from './constants'

export function setTwitchStreaming(streaming) {
    return {
        type: SET_TWITCH_STREAMING,
        payload: streaming,
    }
}

export function setTwitchName(name) {
    return {
        type: SET_TWITCH_NAME,
        payload: name,
    }
}

export function setTwitchUrl(url) {
    return {
        type: SET_TWITCH_URL,
        payload: url,
    }
}

export function updateTwitch(status) {
    return {
        type: UPDATE_TWITCH,
        payload: status,
    }
}



// WEBPACK FOOTER //
// ./src/features/Sync/data/twitch/actions.js